import { post } from 'wtb-utils';

const url = process.env.REACT_APP_API_URL;

function saveLanguageToBE(id, language) {
  return post(`${url}/${id}/language`, { language });
}

export default saveLanguageToBE;
